import fixture from './BuyerRegistrationProfileInfo.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IBuyerRegistrationProfileInfoClient,
} from 'interfaceAdapter/gatewaySchemas/IBuyerRegistrationProfileInfoClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/buyer/registration_profile_info`;

export class BuyerRegistrationProfileInfoClient implements IBuyerRegistrationProfileInfoClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, supporterToken, mock = false } = input;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        // 買い手ユーザートークンまたはサポータートークンを設定
        if (token) {
            headers['X-HTTP-AUTH-TOKEN-B'] = token;
        }
        if (supporterToken) {
            headers['X-HTTP-AUTH-TOKEN-S'] = supporterToken;
        }

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
